import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class StatesBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.states = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let states = ko.unwrap(value);

                (element as any).alterClass('c-state-*');

                for (let i = 0; i < states.length; i++) {
                    element.addClass('c-state-' + states[i]);
                }
            }
        };
    }
}